<template>
  <div class="input-search">
    <input type="text" v-model="qTerm" placeholder="Search term"
           @keyup.enter="termAdd">
    <button class="btn btn-search" @click="termAdd"></button>
    <ul class="my1">
      <li v-for="term in terms" :key="term" class="text-tag">
        {{term}}<span class="text-tag-close" @click="termRemove(term)"> ❌</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FilterTerm',
  components: { },
  props: {
    initTerms: Array,
  },

  data() {
    return {
      qTerm: null, // input value, not on search yet
      terms: [], // list of terms
    };
  },

  created() {
    this.terms = this.initTerms || [];
  },

  watch: {
    initTerms: {
      immediate: true,
      handler(val) {
        this.terms = val || [];
      },
    },
  },

  methods: {
    termAdd() {
      if (this.qTerm === null) {
        return;
      }
      const trimmed = this.qTerm.trim();
      if (!trimmed) {
        return;
      }
      this.terms.push(trimmed);
      this.qTerm = '';
      this.$nextTick()
        .then(() => {
          this.$emit('updateTerms', this.terms);
        });
    },
    termRemove(term) {
      this.terms = this.terms.filter((item) => item !== term);
      this.$nextTick()
        .then(() => {
          this.$emit('updateTerms', this.terms);
        });
    },
  },
};
</script>

<style scoped>
</style>
